/**
 * VoxPont2 — independent Live Translate configuration.
 *
 * WHAT: Route, model id, and usage-cap constants for the VoxPont2 engine.
 * WHY: VoxPont2 is a fully self-contained fork of /voxpont (carecompris2) so it can advance
 *      independently; it must NOT import from or mutate carecompris/carecompris2.
 * INVARIANT: featureGateKey must match a registered gate in shared-utils featureGates.js.
 * Coupling: useVoxPont2Translator, VoxPont2Page, voxpont2UsageService.
 */

/** Public route for VoxPont2 sessions. */
export const VOXPONT2_PUBLIC_PATH = '/voxpont2';

export const VOXPONT2_CONFIG = {
  /** Gemini Live Translate model (June 2026 preview). */
  translateModel: 'gemini-3.5-live-translate-preview',

  // NOTE (billing SKU — open decision): VoxPont2 currently shares the existing
  // 'carecompris-translate' usage gate so it works without backend gate changes. A dedicated
  // VoxPont2 gate/field/collection is a follow-up once the SKU decision is made; switching
  // these constants is all that is needed on the client side then.
  featureGateKey: 'carecompris-translate',
  freeSessionLimit: 3,
  usageCapField: 'carecomprisTranslateSessions',
  sessionCollection: 'carevoice2Sessions',

  /** Firestore encounter field — distinct from carecompris/carecompris2 so writes never collide. */
  encounterField: 'careVoice2Translation',

  route: VOXPONT2_PUBLIC_PATH,
  engineVersion: 2,
  product: 'carevoice2',

  /** Single-line variant title shown in place of the logo image on mobile. */
  displayTitle: 'VoxPont',
};

const voxpont2Config = { VOXPONT2_CONFIG, VOXPONT2_PUBLIC_PATH };
export default voxpont2Config;
